import {Hydra} from '../generic/hydra';

import {CommissionSeanceInterface} from './CommissionSeance';
import {DossierInterface} from './Dossier';
import {
    DossierChangementCommissionSeanceRequest as DossierChangementCommissionSeanceRequestBaseInterface
} from '../../interface/api/DossierChangementCommissionSeanceRequest';

export type DossierChangementCommissionSeanceRequestInterface = DossierChangementCommissionSeanceRequestBaseInterface;

export class DossierChangementCommissionSeanceRequest extends Hydra implements DossierChangementCommissionSeanceRequestInterface {

    commissionSeance: CommissionSeanceInterface | string = null;

    dossier: DossierInterface | string = null;

    justification?: string | null;

    commissionSeanceQuittee?: CommissionSeanceInterface | string | null;


    constructor(options: DossierChangementCommissionSeanceRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
